import React, { Component } from 'react';
import { StyledHeader } from '../styles';
import ParnerLogo from '../../Content/Shared/PartnerLogo';

class TrygHeader extends Component {
  render() {
    return (
      <StyledHeader background="white" boxShadow="none" marginTop="10px">
        <ParnerLogo
          getTranslation={(messageCode) => this.props.getTranslation(messageCode)}
          isHeaderLogo={true}
        />
      </StyledHeader>
    );
  }
}

export default TrygHeader;
